import { COMING_SOON_LABEL, isTierAvailable } from '@agentic-ivy/shared-types';

/**
 * Model definitions and configurations for AI models
 * Based on gemini-cli core model system
 */

export interface ModelInfo {
  id: string;
  name: string;
  description: string;
  contextWindow: number;
  features: string[];
  category: 'pro' | 'flash' | 'experimental';
}

export const AVAILABLE_MODELS: ModelInfo[] = [
  {
    id: 'gemini-2.5-pro',
    name: 'Advanced',
    description: 'Slower • Best for complex videos & detailed scripts',
    contextWindow: 1048576,
    features: ['Complex animations', 'Multi-slide videos', 'Detailed narration'],
    category: 'pro'
  },
  {
    id: 'gemini-2.5-flash',
    name: 'Base',
    description: 'Faster • Great for simple videos & quick iterations',
    contextWindow: 1048576,
    features: ['Quick previews', 'Simple slides', 'Fast edits'],
    category: 'flash'
  }
];

export const DEFAULT_MODEL = 'gemini-2.5-pro';

export type QualityTier = 'basic' | 'pro' | 'ultramax';

export const QUALITY_TIER_OPTIONS: { id: QualityTier; label: string; description: string; comingSoon: boolean }[] = [
  { id: 'basic', label: 'Basic', description: 'Fast & affordable', comingSoon: !isTierAvailable('basic') },
  { id: 'pro', label: 'Pro', description: 'Opus — the default', comingSoon: !isTierAvailable('pro') },
  { id: 'ultramax', label: 'UltraMax', description: COMING_SOON_LABEL, comingSoon: !isTierAvailable('ultramax') },
];

export const DEFAULT_QUALITY_TIER: QualityTier = 'pro';

export const getModelInfo = (modelId: string): ModelInfo | undefined => {
  return AVAILABLE_MODELS.find(model => model.id === modelId);
};

export const formatContextWindow = (tokens: number): string => {
  if (tokens >= 1000000) {
    return `${(tokens / 1000000).toFixed(1)}M tokens`;
  }
  return `${(tokens / 1000).toFixed(0)}K tokens`;
};